import React, { useState } from "react";
import CustomTabs from "components/tabs/customTab";
import AllDocuments from "./AllDocuments";
import ContractsDocument from "./Contracts";
import PromotionsDocument from "./Promotions";
import CompensationDocument from "./Compensation";
import { FileText, FileCheck, TrendingUp, FileArchive } from "lucide-react";
import AccessButton from "components/button/accessbutton";

const EmployeeDocumentsTabs = ({ documents = [] }) => {
    const [activeTab, setActiveTab] = useState("All Documents");

    const tabOptions = [
        { 
            label: "All Documents", 
            value: "All Documents",
            icon: <FileArchive />
        },
        { 
            label: "Contracts", 
            value: "Contract",
            icon: <FileCheck/>
        },
        { 
            label: "Promotions", 
            value: "Promotion",
            icon: <TrendingUp />
        },
        { 
            label: "Compensation", 
            value: "Compensation",
            icon: <FileText />
        },
    ];

    return (
        <>
            <div className="flex items-center justify-between mb-4">
                <AccessButton
                    backLabel="Employee Details"
                    withBack={true}
                    baseRoute="/console/employee-details"
                />
                <div className="flex-1 ml-2">
                    <CustomTabs
                        tabs={tabOptions}
                        activeTab={activeTab}
                        onChange={setActiveTab}
                        height="h-10"
                    />
                </div>
            </div>
            <div>
                {activeTab === "All Documents" && (
                    <AllDocuments documents={documents} />
                )}

                {activeTab === "Contract" && (
                    <ContractsDocument documents={documents} />
                )}

                {activeTab === "Promotion" && (
                    <PromotionsDocument documents={documents} />
                )}

                {activeTab === "Compensation" && (
                    <CompensationDocument documents={documents} />
                )}
            </div>
        </>
    );
};

export default EmployeeDocumentsTabs;